import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCc1d1ZT7XVAWYoWrB2HV9_BxQJlza_tus",
  authDomain: "athikalai-bakthi.firebaseapp.com",
  projectId: "athikalai-bakthi",
  storageBucket: "athikalai-bakthi.firebasestorage.app",
  messagingSenderId: "628602788534",
  appId: "1:628602788534:web:5ed646797d24e4fb28a417",
  measurementId: "G-GQZERVF7DR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
